import ImageAttachments from '../components/ImageAttachments.js'
import AudioAttachments from '../components/AudioAttachments.js'
import FileAttachments from '../components/FileAttachments.js'
import ButtonAttachments from '../components/ButtonAttachments.js'
import FormAttachments from './FormAttachments.js'
import FormSubmitAttachments from './FormSubmitAttachments.js'
import GenericTemplateAttachments from '../components/GenericTemplateAttachments.js'
//import FormSubmitAttachment from './formSubmitAttachment.js'
import VideoAttachments from '../components/VideoAttachments.js'
import TextMessage from './TextMessage.js'
import InfoMessage from './InfoMessage.js' // message by system like convo join, convo tag, ...

var sb = require('@sb/util')

import store from '@sb/store'

export default {
	props: ['event'],
	data () {
		return {
			refresh: false,
		}
	},

	render () {
		var ev = sb.get(this.event, 'ev', {})
		switch (ev.type) {
		case 'conversation_joined':
			// return this.renderMessageChatJoin()
			break
		case 'message_sent':
			return this.renderMessageSent()
		case 'conversation_state_updated':
		case 'conversation_rating_requested':
		case 'conversation_rated':
			if (!sb.startsWith(ev.id, 'ev')) return null // don't show local msg (id == idempotency key)
			return <InfoMessage ev={this.event} />
		}
		return null
	},

	methods: {
		focus () {
			this.$refs.formAttachments.focus()
		},

		renderAgentAvatar (ev) {
			let bytype = sb.get(ev, 'by.type')
			let byid = sb.get(ev, 'by.display_id', sb.get(ev, 'by.id'))

			if (bytype === 'user') return null

			var senderName = getSenderName(ev)
			let acc = store.matchAccount()
			var uri = acc.logo_url || require('../../assets/img/image_default.png')

			let agentM = store.matchAgent('*')
			// should replace with subiz logo
			if (byid !== 'system' || bytype !== 'dummy') {
				uri = sb.get(agentM[byid], 'avatar_url') || acc.logo_url || require('../../assets/img/default_avatar.png')
			}

			return (
				<div class="message-sender">
					<img class="message-sender-avatar" src={sb.replaceFileUrl(uri)} />
					<p class="message-sender-name">{senderName}</p>
				</div>
			)
		},

		renderMessageSent () {
			let ev = this.event.ev

			var $time = null
			if (this.event.show_time) {
				$time = (
					<div class="convo-event-time">
						<Time time={ev.created} />
					</div>
				)
			}

			// message of agent
			if (sb.get(ev, 'by.type') !== 'user') {
				let $sender = null
				if (this.event.mode === 'lead') $sender = this.renderAgentAvatar(ev)
				return (
					<div class="convo-event agent-message">
						{$time}
						{$sender}
						<TextMessage ev={ev} />
						<ImageAttachments ev={ev} />
						<AudioAttachments ev={ev} />
						<VideoAttachments ev={ev} />
						<FileAttachments ev={ev} />
						<ButtonAttachments ev={ev} />
						<FormAttachments vOn:submit={this.onFormSubmit} ref="formAttachments" ev={ev} />
						<FormSubmitAttachments ev={ev} />
						<GenericTemplateAttachments ev={ev} />
					</div>
				)
			}

			if (sb.getMsgField(ev, 'idempotency') === ev.id && store.now() - ev.created < 900) {
				setTimeout(() => {
					this.refresh = !this.refresh
				}, 1000)
			}

			// only show sending while the message is send too long (>300ms) but haven't returned from
			// the server
			let $dot = <div class="sending_dot"></div>
			if (store.now() - ev.created < 900 || sb.getMsgField(ev, 'idempotency') !== ev.id) {
				$dot = <div class="sending_dot sending_dot__hide"></div>
			}

			let $sender = null
			if (this.event.mode === 'lead') $sender = <div class="pt-3"></div>

			let $error = null
			if (ev._error) {
				$error = (
					<a class="message_error" src="javascript:;" vOn:click={this.resendMessage}>
						<div class="message_error__text">{this.$t('error_send_message')}</div>
						<div class="message_error__icon" />
					</a>
				)
			}

			return (
				<div class="convo-event user-message">
					{$time}
					{$sender}
					<div class="message-user__container">
						{$dot}
						<TextMessage ev={ev} refresh={this.refresh} />
						<ImageAttachments ev={ev} />
						<AudioAttachments ev={ev} />
						<VideoAttachments ev={ev} />
						<FileAttachments ev={ev} />
						<ButtonAttachments ev={ev} />
						<FormAttachments vOn:submit={this.onFormSubmit} ref="formAttachments" ev={ev} />
						<FormSubmitAttachments ev={ev} />
					</div>
					{$error}
				</div>
			)
		},

		renderUpdateConvo (ev) {
			var state = sb.get(ev, 'data.conversation.state')
			if (state === 'active') return null
			if (state === 'pending') return null
			return <div class="message-system">{this.$t('conversation_state_updated', { state })}</div>
		},

		onFormSubmit () {
			this.$emit('formSubmit')
		},

		resendMessage () {
			let cid = sb.convoOfEv(this.event.ev)
			const message = sb.get(this.event, 'ev.data.message')
			store.sendConvoEvent(cid, 'message_sent', { message })
		},
	},
}

function getSenderName (ev) {
	let bytype = sb.get(ev, 'by.type')
	let byid = sb.get(ev, 'by.display_id', sb.get(ev, 'by.id'))
	if (byid === 'system' || bytype === 'dummy') return 'system'
	let user = store.matchUser()
	let acc = store.matchAccount()
	if (bytype === 'user') return sb.getUserDisplayName(user)
	if (bytype === 'agent') return sb.getAgentDisplayName(acc, store.matchAgent(byid))
	return ''
}
